export const getFileExtensionFromFileName = (name: string) => {
  const reversedName = name?.split(".")?.reverse()?.join(".");

  const trimmedName = name?.trim();

  if (!trimmedName?.includes(".")) {
    return "";
  }

  return reversedName?.split(".")[0]?.toLowerCase();
};
